<div class="add-item-dialog-header"
    style="padding: 30px 24px 0; display: flex; justify-content: space-between; align-items: center;">
    <h1 style="font-size: 24px;">
        Shipment <span style="color:#ff6c36; font-weight: 600;">{{shipmentData?.shipment_number}}</span>
    </h1>
    <button (click)="close()"><i class="fas fa-times" style="font-size: 24px; color: red;"></i></button>
</div>




<div mat-dialog-content>


    <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt temporibus adipisci deserunt quibusdam alias, ut
        magni doloribus consequatur provident minus neque, deleniti repudiandae architecto aut nemo quam assumenda est
        omnis?
    </p>
    <p>
        content Length {{contentList.length}}
    </p>

    <div class="shipment-content-detail-dialog-wrapper">

        <div class="shipment-content-detail-dialog-content-list"
            *ngFor="let content of contentList; let index = index; trackBy:trackByIndex;">
            <div class="shipment-content-detail-fiedl">
                <label for="">Quantity</label>
                <h6>{{content?.quantity}}</h6>
            </div>
            <div class="shipment-content-detail-fiedl">
                <label for="">Description</label>
                <h6>{{content?.description}}</h6>
            </div>

            <div class="shipment-content-detail-fiedl">
                <label for="">Value</label>
                <h6>{{content?.value}}</h6>
            </div>
            <div class="shipment-content-detail-fiedl">
                <label for="">Currency</label>
                <h6>{{content?.currency}}</h6>
            </div>
            <div class="shipment-content-detail-fiedl">
                <label for="">Weight</label>
                <h6>{{content?.weight}}</h6>
            </div>
            <div class="shipment-content-detail-fiedl">
                <label for="">HS Tariff Number</label>
                <h6>{{content?.hs_tariff_number}}</h6>
            </div>
            <div class="shipment-content-detail-fiedl">
                <label for="">Product Identifier</label>
                <h6>{{content?.productIdentifier}}</h6>
            </div>




        </div>



    </div>

</div>





<div mat-dialog-actions style="justify-content: flex-end;">
    <button mat-flat-button color="primary" class="shippn-mat-btn" (click)="close()" cdkFocusInitial>Close</button>
</div>